/* Sekme 3 — atölyeler. Kart tıklanınca uzun açıklama açılır (accordion). */

import { useState } from "react";
import type { Lang, SiteContent } from "../../shared/types.js";
import { t } from "../../shared/types.js";
import { ui } from "../lib/i18n.js";
import { IconChevron } from "../components/Icons.js";

export function WorkshopsTab({ content, lang }: { content: SiteContent; lang: Lang }) {
  const [open, setOpen] = useState<string | null>(null);

  return (
    <div style={{ paddingTop: 28 }}>
      <h2 className="eyebrow">{ui("navWorkshops", lang)}</h2>
      <h1 className="display">{ui("workshopsTitle", lang)}</h1>
      <p className="lede">{ui("workshopsLede", lang)}</p>

      <div className="stack" style={{ gap: 14, marginTop: 24 }}>
        {content.workshops.map((w, i) => {
          const isOpen = open === w.id;
          return (
            <article
              key={w.id}
              className="card rise pressable"
              style={{ ["--i" as string]: Math.min(i, 8), padding: 0 }}
            >
              <button
                type="button"
                className="acc"
                aria-expanded={isOpen}
                aria-controls={"ws-" + w.id}
                aria-label={t(w.name, lang) + " — " + ui(isOpen ? "less" : "more", lang)}
                onClick={() => setOpen(isOpen ? null : w.id)}
                style={{ padding: 20 }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    gap: 12,
                  }}
                >
                  <div style={{ minWidth: 0 }}>
                    <div className="brand">{w.partner}</div>
                    <h3
                      className="serif"
                      style={{ fontSize: 24, lineHeight: 1.18, margin: "8px 0 0" }}
                    >
                      {t(w.name, lang)}
                    </h3>
                  </div>
                  <span className="chip">{t(w.tag, lang)}</span>
                </div>

                <p className="muted" style={{ margin: "10px 0 0", fontSize: 15.5 }}>
                  {t(w.desc, lang)}
                </p>

                <div style={{ marginTop: 14 }}>
                  <p className="dim tnum" style={{ fontSize: 14.5, margin: 0 }}>
                    {w.time}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 12,
                      marginTop: 4,
                    }}
                  >
                    <span className="dim" style={{ fontSize: 14.5, minWidth: 0 }}>
                      {t(w.loc, lang)}
                    </span>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        color: "var(--gold)",
                        fontSize: 13,
                        letterSpacing: "0.08em",
                        textTransform: "uppercase",
                        fontWeight: 600,
                        flex: "none",
                      }}
                    >
                      {ui(isOpen ? "less" : "more", lang)}
                      <IconChevron className="acc__caret" open={isOpen} />
                    </span>
                  </div>
                </div>
              </button>

              <div className="acc__panel" data-open={isOpen} id={"ws-" + w.id}>
                <div className="acc__inner">
                  <p
                    className="muted"
                    style={{
                      margin: 0,
                      padding: "0 20px 20px",
                      fontSize: 15.5,
                      lineHeight: 1.65,
                      textWrap: "pretty",
                    }}
                  >
                    {t(w.detail, lang)}
                  </p>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}
